module.exports = __webpack_public_path__ + "img/pantalla-9-12.8e884558.png";